<style lang="less">
.content {
  background: #f3f3f3;
}
</style>
<template>
    <div class="content">
        <router-view/>
    </div>
</template>

<script>
export default {
  name: 'Content'
}
</script>
